<script>
export default {
  name: "DidoCatalogMessageService",
};
</script>

<script setup>
import { ref } from "vue";

const props = defineProps({
  type: { type: String, required: true },
  dismissible: { type: Boolean, required: true },
});

const show = ref(true);
</script>

<template>
  <div v-if="show" class="q-py-sm">
    <QBanner inline-actions :class="`dido-banner bg-${props.type} text-white`">
      <slot name="content" />
      <template v-if="props.dismissible" #action>
        <QBtn
          size="sm"
          square
          unelevated
          outline
          dense
          icon="mdi-close"
          title="Masquer l'information"
          @click="show = false"
        />
      </template>
    </QBanner>
  </div>
</template>

<style lang="sass" scoped>
.dido-banner
  align-items: flex-start
  padding: 16px
  :deep( .q-banner__actions)
    align-items: flex-start
</style>
